export const managementDictionary = {
  notAttendedGroups: 'Yo`qlama qilinmagan guruhlar',
  notGivenHomeworkGroup: 'Uyga vazifa berilmagan guruhlar',
  warningForUpdate: "Oxirgi ma'lumotlarni ko'rish uchun sahifani yangilang",
  allCount: 'Umumiy soni',
  descriptionRequired: 'Tavsif yozish shart',
}
